<template>
  <v-row
    class="fill-height"
    align="center"
    justify="center"
    style="background: linear-gradient(to right top, #1867c0, #19e5f4)"
  >
    <v-card class="elevation-12" :min-width="400">
      <v-toolbar dark color="primary">
        <v-toolbar-title>Reset Password</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text class="pb-0">
        <v-alert type="info" v-if="isRequest">
          {{ message }}
        </v-alert>
        <v-form>
          <template v-if="isRequest">
            <v-text-field
              v-model="email"
              label="Email"
              :outlined="outlinedInputs"
            />
            <v-text-field
              v-model="username"
              label="Username"
              :outlined="outlinedInputs"
            />
          </template>
          <template v-else-if="isExpired">
            <v-alert type="error">
              Your Password reset link has expired! Please request a
              <v-btn small color="secondary" @click="onRequestNewLink"
                >new link</v-btn
              >
            </v-alert>
          </template>
          <template v-else>
            <v-text-field
              v-model="password"
              label="Your New Password"
              :outlined="outlinedInputs"
              type="password"
            />
            <v-text-field
              v-model="confirmPassword"
              label="Confirm Password"
              :outlined="outlinedInputs"
              type="password"
            />
            <v-alert
              type="error"
              v-if="!isValidPassword && password.length > 0"
            >
              {{ errorPasswordMessage }}
            </v-alert>
          </template>
          <v-alert type="error" v-if="error"
            >{{ error }} Please request a
            <v-btn small color="secondary" @click="onRequestNewLink"
              >new link</v-btn
            ></v-alert
          >
        </v-form>
        <v-row v-if="debug">
          <v-col>
            <pre>{{ message }}</pre>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer
        ><v-btn
          v-if="!isExpired"
          color="primary"
          :disabled="
            isRequest ? !isValidEmail || username == '' : !isValidPassword
          "
          @click="onSubmit"
          >Submit</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-row>
</template>

<script>
import gql from "graphql-tag";
const REQUEST_PASSWORD_RESET = gql`
  mutation requestPasswordReset($email: String!, $username: String!) {
    requestPasswordReset(email: $email, username: $username) {
      success
      message
    }
  }
`;
const RESET_PASSWORD = gql`
  mutation resetPassword($token: String!, $password: String!) {
    resetPassword(token: $token, password: $password) {
      success
      message
    }
  }
`;
const VK_INFO = gql`
  query vKinfo($key: String!) {
    verificationKey(key: $key) {
      is_expired
      id
      created_at
    }
  }
`;
export default {
  name: "reset-password",
  data() {
    return {
      debug: false,
      token: this.$route.params.token,
      email: "",
      message:
        "Enter your email address below and we'll send you a link with instructions.",
      password: "",
      username: "",
      confirmPassword: "",
      error: "",
      errorPasswordMessage:
        "Password must be at least 10 characters long, contain at least one uppercase letter, two numbers and two special characters.",
      isExpired: false,
    };
  },

  computed: {
    isRequest() {
      return !this.token;
    },
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    isValidEmail() {
      return this.email.includes("@");
    },
    isValidPassword() {
      // Count special characters and numbers
      const specialChars = (this.password.match(/[^\w]/g) || []).length;
      const numbers = (this.password.match(/[0-9]/g) || []).length;
      return (
        this.password.length >= 10 &&
        /[A-Z]/.test(this.password) &&
        numbers >= 2 &&
        specialChars >= 2 &&
        this.password === this.confirmPassword
      );
    },
  },
  methods: {
    onRequestNewLink() {
      this.isExpired = false;
      this.error = "";
      this.token = null;
    },
    onSubmit() {
      if (this.isRequest) {
        this.requestPasswordReset();
      } else {
        this.resetPassword();
      }
    },
    async requestPasswordReset() {
      try {
        const { data } = await this.$apollo.mutate({
          mutation: REQUEST_PASSWORD_RESET,
          variables: { email: this.email, username: this.username },
        });
        if (data.requestPasswordReset.success) {
          this.message = data.requestPasswordReset.message;
        } else {
          this.error = data.requestPasswordReset.message;
        }
      } catch (error) {
        this.error = error.message;
      }
    },
    async resetPassword() {
      try {
        const { data } = await this.$apollo.mutate({
          mutation: RESET_PASSWORD,
          variables: { token: this.token, password: this.password },
        });

        if (data.resetPassword.success) {
          this.message = data.resetPassword.message;
          //console.log(this.message);
          this.$store.dispatch("showAppSnackbar", {
            msg: data.resetPassword.message,
            color: "success",
          });
          //redirect to login
          this.$router.push("/");
        } else {
          this.error = data.resetPassword.message;
        }
      } catch (error) {
        this.error = error.message.replace("GraphQL error: ", "");
      }
    },
  },
  apollo: {
    verificationKey: {
      query: VK_INFO,
      variables() {
        return { key: this.token };
      },
      skip() {
        return this.token ? false : true;
      },
      result({ data }) {
        if (data.verificationKey && data.verificationKey.is_expired) {
          this.isExpired = true;
        }
      },
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/pages/ResetPassword.vue